export const aCustomCssVarsParam = (booleans?: Record<string, boolean>) => ({
  styleParams: {
    booleans,
    colors: undefined,
    numbers: undefined,
    fonts: undefined,
    strings: undefined,
  },
  isMobile: false,
  isRTL: false,
  tpaData: undefined,
});

export function toDisplayProperty(visibility: boolean, display: string = 'block') {
  return visibility ? display : 'none';
}
